import React from "react"
import AppBar from "components/AppBar"
import usePlanningCalendar from "app/hooks/usePlanningCalendar"
import { StyledRightContainer, StyledTodayButton } from "./style"
import LeftComponent from "./LeftComponent"

type PersonalPlanningNavigationBarProps = {}

const PersonalPlanningNavigationBar: React.FC<PersonalPlanningNavigationBarProps> = () => {
  const { setToday } = usePlanningCalendar()

  return (
    <AppBar
      leftComponent={<LeftComponent />}
      rightComponent={
        <StyledRightContainer>
          <StyledTodayButton buttonVariant="ghost" onClick={setToday} />
        </StyledRightContainer>
      }
    />
  )
}

export default PersonalPlanningNavigationBar
